<h2 mat-dialog-title>{{ 'add_words_quick' | phrase }}</h2>

<button mat-icon-button class="dialog-drag-handle" cdkDragHandle [disableRipple]="true" mat-dialog-title cdkDrag
  cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle cdkDragBoundary="body">
  <svg _ngcontent-ahf-c139="" width="24px" fill="currentColor" viewBox="0 0 24 24">
    <path _ngcontent-ahf-c139=""
      d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
    </path>
    <path _ngcontent-ahf-c139="" d="M0 0h24v24H0z" fill="none"></path>
  </svg>
</button>
<button class="close-dialog-button" mat-icon-button mat-dialog-title (click)="close()">
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content class="shto-fjalen-shpejt-content">
  <form [formGroup]="shtoFjalenFormGroup" (ngSubmit)="onSubmit()">
    <div class="words" formArrayName="fjalet">
      <div class="wrapper" *ngFor="let i = index">
        <button class="remove-btn" color="warn" mat-icon-button (click)="removeControl(i)" *ngIf="i > 0">
          <mat-icon>close</mat-icon>
        </button>
        <div [formGroupName]="i">
          <div class="editor-head">
            <div class="nyja">
              <mat-form-field class="node-form-field" matTooltip="{{ 'editor_node_tooltip' | phrase }}"
                matTooltipPosition="below" matTooltipShowDelay="300">
                <mat-select formControlName="nyjaId">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let nyja of Nyjet" [value]="nyja.id">{{ nyja.long }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="fjala">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{ 'editor_word_label' | phrase }}</mat-label>
                <input matInput formControlName="fjala" spellcheck="false"
                  [placeholder]="'editor_word_placeholder' | phrase" autocomplete="off" spellcheck="false" />
              </mat-form-field>
            </div>
            <div class="homonimi">
              <mat-form-field class="homonym-form-field" matTooltip="{{ 'editor_homonym_tooltip' | phrase }}"
                matTooltipPosition="below" matTooltipShowDelay="300">
                <mat-select formControlName="homonimi">
                  <mat-option *ngFor="let homonimi of Homonimet" [value]="homonimi.id">{{ homonimi.long }} </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <as-card [label]="'editor_partofspeech_label' | phrase">
            <!-- <as-pjesa-ligjerates [bazaFormGroup]="fjalaGroup"></as-pjesa-ligjerates> -->
          </as-card>
        </div>
      </div>
    </div>
  </form>

  <div class="buttonsWrap">
    <button class="addWord mat-primary" mat-icon-button (click)="addControl()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close()">{{ 'button_cancel' | phrase }}</button>
  <!-- <button mat-button [disabled]="!shtoFjalenFormGroup.valid" (click)="onSubmit()">{{ 'button_save' | phrase }}</button> -->
</div>
